

<template>
    <div class="refer-fixtop">
        <img :src="imgurl" alt="">
        <p> {{ $t('topfix.content') }} <a @click="referSignup">{{ $t('topfix.get') }}↗</a></p>
    </div>
</template>

<script setup>
import { inject, getCurrentInstance } from 'vue';
const toSignUpHandle = inject('toSignUpHandle');
const imgurl = getCurrentInstance().appContext.config.globalProperties.$utility.assetImage('coin');
const referSignup = () => {
    toSignUpHandle();
};
</script>

<style scoped lang="scss">
p {
    font-family: 'PingFang SC';
}
a {
    font-family: 'PingFang SC';
}
@media (min-width: 1000px) {
    .refer-fixtop {
        position: fixed;
        top: 0;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 40px);
        margin-left: 20px;
        background-color: #1B1C1F;
        z-index: 12;
        border-radius: 4px;
        img {
            width: 24px;
            height: 24px;
            margin-right: 12px;
        }
        p {
            font-size: 18px;
            padding: 0;
            margin: 0;
            color: #fff;
            a {
                color: #FF7839;
                text-decoration: underline;
                cursor: pointer;
            }
        }
    }
}
@media (max-width: 999px) {
    .refer-fixtop {
        position: fixed;
        top: 0;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 20px);
        margin-left: 10px;
        background-color: #1B1C1F;
        z-index: 12;
        border-radius: 4px;
        img {
            width: 24px;
            height: 24px;
            margin-right: 12px;
        }
        p {
            font-size: 18px;
            padding: 0;
            margin: 0;
            color: #fff;
            a {
                color: #FF7839;
                text-decoration: underline;
                cursor: pointer;
            }
        }
    }
}
</style>